var Frontpages = function() {
    var today = new Date();
    var yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    var cur_img_w = 0;
    var cur_img_h = 0;

    var resize_choco_content = function() {

        var new_width = cur_img_w * 1.1;
        var new_height = cur_img_h * 1.1;
        var new_left = ($(window).width() - new_width) / 2;
        var new_top = 0;

        $('.chocolat-content').animate({
            width: new_width + 'px',
            height: new_height + 'px',
            left: new_left + 'px',
            top: new_top + 'px'
        }, 500);
    };

    var body_observer = new MutationObserver(function(mutations){
        var $body = $(mutations[0].target);

        if ($body.hasClass('chocolat-open')) {
            if (!$body.hasClass('chocolat-zoomed')) {
                setTimeout(function(){
                    resize_choco_content();
                }, 325);
            }
        }
    });

    return {
        init: function(){
            var choco = {};
            // enable datepicker_input after doc is ready
            // (clicking on it before $(document).ready... breaks it's style)
            $('#datepicker_input').prop('disabled', false);

            DatePicker.init();
            $('.date').datepicker({
                format: 'dd/mm/yyyy',
                startDate: '14/11/2012',
                orientation: 'bottom left',
                autoclose: true,
                todayHighlight: true,
                language: 'el',
                maxViewMode: 2,
                todayBtn: 'linked'
            });

            if (!Generic.mobile) {
                choco = Frontpages.chocolatInit();
            }

            $('.date').on('changeDate', function() {
                if (!Generic.mobile) {
                    choco.api().destroy();
                }
                // disable datepicker_input until we load the new frontpages
                $('#datepicker_input').prop('disabled', true);

                var day = $('.date').datepicker('getDate');
                var formatted_day = DatePicker.formatDate(day);

                $('#btn_tod, #btn_yest').removeClass('active');

                if (formatted_day == DatePicker.formatDate(today)) {
                    $('#btn_tod').addClass('active');
                } else if (formatted_day == DatePicker.formatDate(yesterday)) {
                    $('#btn_yest').addClass('active');
                }

                Generic.showProgressLoader();
                Ajax.getFrontpages(formatted_day, function(res) {
                    if (res.success == 'ok' && res.html) {
                        $('#frontpages').html(res.html);
                        $('#datepicker_input').prop('disabled', false);
                        var url = (Generic.mobile ? '/m' : '') + '/protoselida?d=' + formatted_day;
                        window.history.pushState('new_state','', url);
                        Generic.hideProgressLoader();
                        if (!Generic.mobile) {
                            choco = Frontpages.chocolatInit();
                        }
                    }
                });
            });

            // reload when pressing back or fwd browser button
            $(window).on('popstate', function(){
                window.location.href = window.location.href;
            });

            $('.btn_fp').on('click', function() {
                var date = today;
                if ($(this).attr('id') == 'btn_yest') {
                    date = yesterday;
                }
                $('.date').datepicker('setDate', new Date(date));
            });
        },
        chocolatInit: function() {
            return $('#frontpages').Chocolat({
                imageSize: 'contain',
                loop: true,
                afterInitialize: function() {
                    $('.chocolat-wrapper').css('z-index', 1300);
                    body_observer.observe(document.querySelector('body'), {attributes: true});
                },
                afterImageLoad: function() {
                    cur_img_w = parseInt($('.chocolat-content').width());
                    cur_img_h = parseInt($('.chocolat-content').height());
                    resize_choco_content();
                }
            }).data('chocolat');
        }
    };


}();
